import {
    MeetingTranscriptSources,
    TMeetingTranscriptResponse,
    PriorityListConfig,
    BusinessTrendsConfig
} from '~/apps/main/CompanySettings/AISettings/AISettings.consts';
import { BaseHttpAdapter } from '~/services/adapters/base-http.adapter';
export class AiPreferencesAdapter extends BaseHttpAdapter {
    // update Hot leads
    updatePriorityLeadOptIn(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'POST',
            url: `/api/v2/update_hot_leads_opt_in/${optIn}`,
            data: {}
        });
    }

    // update AI for projects + leads
    updateAISuggestionEnabled(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'POST',
            url: `/api/v2/suggestion/toggle`,
            data: {
                opt_in: optIn
            }
        });
    }

    // update AI injection into composer
    updateAIComposerInjectionEnabled(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'POST',
            url: `/api/v2/suggestion/toggle_composer_ai_injection`,
            data: {
                opt_in: optIn
            }
        });
    }

    updateProjectRecapsEnabled(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'PUT',
            url: `/api/v2/project_recaps/pre_meeting_settings`,
            data: {
                enabled: optIn
            }
        });
    }

    updateProjectRecapsForProjectDatesEnabled(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'PUT',
            url: `/api/v2/project_recaps/pre_project_settings`,
            data: {
                enabled: optIn
            }
        });
    }

    getIsProjectRecapsEnabled() {
        return this.apiService.apiRequest<{
            enabled: boolean;
            is_gate_open: boolean;
        }>({
            method: 'GET',
            url: `/api/v2/project_recaps/pre_meeting_settings`
        });
    }
    getIsProjectRecapsForProjectDatesEnabled() {
        return this.apiService.apiRequest<{
            enabled: boolean;
            is_gate_open: boolean;
        }>({
            method: 'GET',
            url: `/api/v2/project_recaps/pre_project_settings`
        });
    }
    getIsMeetingTranscriptEnabled(source: MeetingTranscriptSources) {
        return this.apiService.apiRequest<TMeetingTranscriptResponse>({
            method: 'GET',
            url: `/api/v2/transcript/settings/${source}`
        });
    }

    getIsLeadsCaptureEnabled() {
        return this.apiService.apiRequest<{
            enabled: boolean;
            is_eligible: boolean;
        }>({
            method: 'GET',
            url: `/api/v2/users/leads_capture_enabled`
        });
    }

    updateMeetingTranscriptEnabled({
        sources,
        enabled
    }: {
        sources: MeetingTranscriptSources[];
        enabled: boolean;
    }) {
        return this.apiService.apiRequest<void>({
            method: 'PUT',
            url: `/api/v2/transcript/settings`,
            data: {
                sources,
                enabled
            }
        });
    }

    updateLeadsCaptureEnabled(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'PUT',
            url: `/api/v2/users/leads_capture_enabled`,
            data: {
                enabled: optIn
            }
        });
    }

    getIsInPersonAssistantEnabled() {
        return this.apiService.apiRequest<{
            enabled: boolean;
            is_gate_open: boolean;
        }>({
            method: 'GET',
            url: '/api/v2/transcript/audio_settings'
        });
    }

    updateInPersonAssistantEnabled(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'PUT',
            url: `/api/v2/transcript/audio_settings`,
            data: {
                enabled: optIn
            }
        });
    }

    getPriorityListConfig() {
        return this.apiService.apiRequest<{
            enabled: boolean;
            schedule: string;
        }>({
            method: 'GET',
            url: `/api/v2/users/priority_list_config`
        });
    }

    updatePriorityListConfig(config: Partial<PriorityListConfig>) {
        return this.apiService.apiRequest<{
            enabled: boolean;
            schedule: string;
        }>({
            method: 'PUT',
            url: `/api/v2/users/priority_list_config`,
            data: {
                enabled: config.isEnabled,
                schedule: config.schedule
            }
        });
    }

    getBusinessTrendsConfig() {
        return this.apiService.apiRequest<{
            enabled: boolean;
            schedule: string;
        }>({
            method: 'GET',
            url: `/api/v2/users/business_trends_config`
        });
    }

    updateBusinessTrendsConfig(config: Partial<BusinessTrendsConfig>) {
        return this.apiService.apiRequest<{
            enabled: boolean;
            schedule: string;
        }>({
            method: 'PUT',
            url: `/api/v2/users/business_trends_config`,
            data: {
                enabled: config.isEnabled,
                schedule: config.schedule
            }
        });
    }

    updateFollowUpSuggestionsEnabled(optIn: boolean) {
        return this.apiService.apiRequest<void>({
            method: 'PUT',
            url: `/api/v2/suggestions/unconverted_lead_followup_suggestions_config`,
            data: {
                enabled: optIn
            }
        });
    }

    getIsFollowUpSuggestionsEnabled() {
        return this.apiService.apiRequest<{
            enabled: boolean;
            is_eligible: boolean;
        }>({
            method: 'GET',
            url: `/api/v2/suggestions/unconverted_lead_followup_suggestions_config`
        });
    }
}
